import React, { useRef } from "react";
import { BiImageAdd } from "react-icons/bi";
import { RxCross2 } from "react-icons/rx";
import { BsExclamationCircleFill } from "react-icons/bs";
import toast from "react-hot-toast";
import { isImage } from "../../utils/commonFunctions";

/**
 * @function CustomImgUpload
 * @description for CustomImgUpload
 * @returns JSX for CustomImgUpload
 */

const UpdateSiteImageUpload = ({
  prevFiles,
  currFiles,
  currFilesHanlder,
  prevFileHandler,
  defaultImageIndex,
  defaultImageIndexHandler,
}) => {
  const hiddenFileInput = useRef(null);
  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  function handleImageChange(event) {
    const selectedFiles = Array.from(event.target.files);
    // const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
    // const invalidFiles = selectedFiles.filter(
    //   (file) => !allowedTypes.includes(file.type)
    // );

    // if (invalidFiles.length > 0) {
    //   toast.error(
    //     `Only images of JPG/JPEG/PNG formate are allowed ${invalidFiles.length} Ignored`
    //   );
    // }

    // const validFiles = selectedFiles.filter((file) =>
    //   allowedTypes.includes(file.type)
    // );

    // const allFiles = [...currFiles, ...validFiles];
    // Use a Map to ensure unique file names and maintain their associated data
    const uniqueFilesMap = new Map();
    let duplicateCount = 0,
      largeFileCount = 0;

    console.log("selected files :", selectedFiles);
    selectedFiles.forEach((file) => {
      if (!uniqueFilesMap.has(file.name)) {
        if (file.size > 5 * 1024 * 1024) {
          largeFileCount++;
        } else uniqueFilesMap.set(file.name, file);
      } else {
        duplicateCount++;
      }
    });

    // Convert the Map values back to an array if needed
    const uniqueFiles = Array.from(uniqueFilesMap.values());
    if (duplicateCount && largeFileCount) {
      toast.error(
        `${duplicateCount} duplicate image(s) and ${largeFileCount} image(s) exceeding 5MB were detected and removed.`
      );
    } else if (duplicateCount) {
      toast.error(
        `${duplicateCount} duplicate image(s) were detected and removed.`
      );
    } else if (largeFileCount) {
      toast.error(
        `File size limit is 5MB. ${largeFileCount} file(s) exceed this limit.`
      );
    }

    currFilesHanlder([...currFiles, ...uniqueFiles]);
  }

  const handleDeletePrevPhoto = (fileToDelete) => {
    const updatedImages = prevFiles?.filter((file) => file !== fileToDelete);
    prevFileHandler(updatedImages);
    if (defaultImageIndex >= updatedImages.length + currFiles?.length) {
      defaultImageIndexHandler(0);
    }
  };

  const handleDeleteCurrPhoto = (fileToDelete) => {
    const updatedImages = currFiles?.filter(
      (file) =>
        file.name !== fileToDelete.name &&
        file.lastModified !== fileToDelete.lastModified
    );
    currFilesHanlder(updatedImages);
    if (defaultImageIndex >= updatedImages.length + prevFiles?.length) {
      defaultImageIndexHandler(0);
    }
  };

  const prevImageCards = () => {
    return (
      <>
        {prevFiles?.length > 0 &&
          prevFiles?.map((img, i) => (
            <div key={i}>
              <div className="box-decoration positon-relative" key={i}>
                <button
                  type="button"
                  className="cross-btn"
                  onClick={() => handleDeletePrevPhoto(img)}
                  style={{ zIndex: "100" }}
                >
                  <RxCross2 className="btn-icons" />
                </button>
                {isImage(img) ? (
                  <img
                    src={img}
                    alt="Site Image"
                    className="images"
                    loading="lazy"
                  />
                ) : (
                  <video className="images" alt="site video" controls muted>
                    <source src={img}></source>
                  </video>
                )}
              </div>
              <div className="default--mark--container ">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="isRecommend"
                  checked={defaultImageIndex === i}
                  onChange={() => defaultImageIndexHandler(i)}
                />
                <label className="img--default--text">
                  {"Mark as Default"}
                </label>
              </div>
            </div>
          ))}
      </>
    );
  };

  const imageCards = () => {
    return (
      <>
        {currFiles?.length > 0 &&
          Object.entries(currFiles).map(([key, value], i) => {
            const index = prevFiles?.length + i;
            return (
              <div key={index}>
                <div className="box-decoration positon-relative">
                  <button
                    type="button"
                    className="cross-btn"
                    onClick={() => handleDeleteCurrPhoto(value)}
                  >
                    <RxCross2 className="btn-icons" />
                  </button>
                  {/* <img
                    src={URL.createObjectURL(value)}
                    alt="Site Image"
                    className="images"
                    loading="lazy"
                  /> */}

                  {value?.type.startsWith("image/") ? (
                    <img
                      src={URL.createObjectURL(value)}
                      alt="Site Image"
                      className="images"
                      loading="lazy"
                    />
                  ) : (
                    <video className="images" alt="site video" controls muted>
                      <source src={URL.createObjectURL(value)}></source>
                    </video>
                  )}
                </div>
                <div className="default--mark--container">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="isRecommend"
                    checked={defaultImageIndex === index}
                    onChange={() => defaultImageIndexHandler(index)}
                  />
                  <label className="img--default--text">
                    {"Mark as Default"}
                  </label>
                </div>
              </div>
            );
          })}
      </>
    );
  };
  return (
    <div className="upload-img-main-container">
      <div className="img-guildlines">
        <span>
          <BsExclamationCircleFill />
        </span>
        <p className="img-guildlines-para">
          {
            "You are allowed to uploads files with the following formates : JPG/JPEG/PNG/WEBP . The maximum image size is permitted is 20 MB maintain a consistent of 1:1 aspect ratio for images."
          }
        </p>
      </div>
      <div className="upload-img-wrapper">
        <div className="box-decoration" onClick={handleClick} name={"images"}>
          <label
            htmlFor="image-upload-input"
            className="image-upload-label label-container"
          >
            <div className="m-0 p-0 d-flex flex-column justify-center align-items-center">
              <span className="label-icons">
                <BiImageAdd />
              </span>
              <span className="label-heading">
                {"Add Images "}
                <span className="label-star">*</span>
              </span>
            </div>
            <span className="lable-para">{"or drag and drop here"}</span>
            <span className="lable-warning">
              {
                "Check the image upload guidlines before uploading the images (Recommended)."
              }
            </span>
          </label>
          <div>
            <input
              multiple
              type="file"
              onChange={handleImageChange}
              ref={hiddenFileInput}
              className="image-upload-input"
              accept="image/png , image/jpeg, image/webp  , video/mp4"
              // accept="image/png, image/jpg, image/jpeg, image/webp"
            />
          </div>
        </div>
        {prevImageCards()}
        {imageCards()}
      </div>
    </div>
  );
};

export default React.memo(UpdateSiteImageUpload);
